import { Link } from "react-router-dom";
import { characters } from "@/mocks/characters";
import SectionHeading from "@/components/feature/SectionHeading";

function CharacterPreview() {
  const list = characters.slice(0, 4);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeading
          eyebrow="角色设定"
          title="主要角色速览"
          desc="从主角阿浩到吉祥物嘿咻猫咪，认识每一个让故事温暖起来的人。"
        />
        <Link
          to="/characters"
          className="mb-8 inline-flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 whitespace-nowrap"
        >
          查看全部角色 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {list.map((c) => (
          <Link
            key={c.id}
            to="/characters"
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={c.image}
                alt={`角色设定：${c.name}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                  {c.role.split("·")[0]}
                </span>
              </div>
              <p className="mt-1 text-xs text-foreground-500">{c.role}</p>
              <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {c.intro}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default CharacterPreview;